import { Sphere, useScroll } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { Depth, Displace, Fresnel, LayerMaterial } from "lamina";
import { useRef } from "react";
import { Vector3 } from "three";
import ChaosMaterial from "./ChaosMaterial";
import { easeInBack, easeOutBack, easeOutCirc } from "./Utils";

export default function Blob({ displaceProps, ...props }) {
  const ref = useRef(null);
  const scroll = useScroll();
  const displaceRef = useRef({ strength: 0, offset: [0, 0, 0] });

  // [설정/블롭] 1-4 페이지를 지나가는 동안 보여짐
  const theta = Math.random() * Math.PI * 2; // 위에서 봤을 때 떨어지는 각도
  const startOffset = 0.05 + Math.random() * 0.1; // 떨어지기 시작하는 시점
  const speed = Math.random() + 3; // 떨어지는 속도
  const amplitude = Math.random() * 2 + 3; // 떨어질 때 퍼지는 정도

  const startPosition = new Vector3(
    (Math.random() - 0.5) * 35,
    (Math.random() - 0.7) * 35,
    (Math.random() - 0.5) * 25 - 10
  );
  const sizeStart = 30 + Math.random() * 60;
  const sizeEnd = 30 + Math.random() * 15;
  useFrame(() => {
    const t = Math.max(Math.min(scroll.offset, 0.5) - startOffset, 0) * speed;

    ref.current.position.x =
      startPosition.x +
      easeOutCirc(t) * Math.sin(theta + t * Math.PI) * amplitude;
    ref.current.position.y = startPosition.y + t * -30; // -40 : 안정적으로 가려지는 위치
    ref.current.position.z =
      startPosition.z +
      easeOutCirc(t) * Math.cos(theta + t * Math.PI) * amplitude;

    // 떨어지면서 사이즈가 커짐

    ref.current.scale.x = sizeStart + easeOutCirc(t) / sizeEnd;
    ref.current.scale.y = sizeStart + easeOutCirc(t) / sizeEnd;
    ref.current.scale.z = sizeStart + easeOutCirc(t) / sizeEnd;

    // ref.current.rotation.y += 0.01;
    // ref.current.rotation.z += 0.005;
  });

  return (
    <group ref={ref} {...props}>
      <Sphere args={[0.05, 64, 64]}>
        {props.chaos ? (
          <ChaosMaterial />
        ) : (
          <LayerMaterial
            color={"#ffffff"}
            lighting={"physical"} //
            transmission={Math.random() / 2 + 0.5}
            roughness={1}
            thickness={1}
            transparent={true}
            metalness={1.5}
            alpha={0.7}
          >
            {/* {true ? (
            <Displace
              ref={displaceRef}
              type={"curl"}
              strength={0.035}
              scale={1.75}
              offset={[Math.random(), Math.random(), 0]}
            />
          ) : null} */}
            <Depth
              near={0.4854}
              far={0.7661999999999932}
              origin={[-0.4920000000000004, 0.4250000000000003, 0]}
              colorA={"#FEC5DA"}
              colorB={"#535ffe"}
              mode={"multiply"}
              alpha={1}
              transparent={true}
            />
            {props.fresnel ? (
              <Fresnel
                color={"#fefefe"}
                bias={-0.3430000000000002}
                intensity={0.8999999999999946}
                power={3.3699999999999903}
                factor={1.119999999999999}
                mode={"screen"}
              />
            ) : null}
          </LayerMaterial>
        )}
      </Sphere>
    </group>
  );
}
